import { configureStore, combineReducers } from '@reduxjs/toolkit';
import user from './user';
import applicantPartners from './applicant.partners';
import partner from './partner';
import jobs from './jobs';
import jobsSearch from './jobs.search'

// Create the root reducer separately so we can extract the RootState type
const rootReducer = combineReducers({
  user: user,
  applicantPartners: applicantPartners,
  partner: partner,
  jobs: jobs,
  jobsSearch: jobsSearch,
});

export const setupStore = preloadedState => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  });
};